import { Avatar, Box, IconButton, Menu, Tooltip } from "@mui/material";
import { memo, useState } from "react";
import Translation from "../../utils/Translation";
import MenuItem from "@mui/material/MenuItem";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { checkStorePage, checkUserIsSeller } from "../../utils/helpers";

const UserAvatar = ({ HandleUserLogoutClick }) => {
  const dispatch = useDispatch();
  const [anchorElUser, setAnchorElUser] = useState(null);
  const { userProfile } = useSelector((state) => state.profile);
  const [settings, setSettings] = useState([]);

  useState(() => {

    if (userProfile !== null) {
      setSettings(
        checkUserIsSeller(userProfile)
          ? ["profile", "store", "setting", "logout"]
          : checkStorePage()
            ? ["profile", "orders", "setting", "logout"]
            : ["profile", "address", "setting", "logout"]
      );
    }

  }, [dispatch, userProfile]);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <Box sx={{ flexGrow: 0 }}>
      <Tooltip title={<Translation data="layout.profile" />}>
        <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
          <Avatar
            src={
              userProfile?.profile_image_url
                ? userProfile.profile_image_url
                : require("../../assets/image/profile/avatar.jpg")
            }
          />
        </IconButton>
      </Tooltip>
      <Menu
        sx={{ mt: "45px" }}
        id="menu-appbar"
        anchorEl={anchorElUser}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
        {settings.map((setting, idx) => (
          <MenuItem
            key={idx}
            onClick={() => {
              HandleUserLogoutClick(setting);
              handleCloseUserMenu();
            }}
          >
            <Translation data={"layout." + setting} />
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default memo(UserAvatar);
